import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import { EventReducedFragmentDoc } from '../fragments/eventReducedFragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateEventMutationVariables = Types.Exact<{
  event_id: Types.Scalars['ID'];
  input: Types.UpdateEventInput;
}>;


export type UpdateEventMutation = { __typename?: 'Mutation', updateEvent: { __typename?: 'Event', id: string, external_zoho_id?: string | null, name?: string | null, description?: string | null, image_url?: string | null, start_date?: string | null, end_date?: string | null, is_authorized_signer_necessary: boolean, currency: string, entity: Types.LegalEntity, type: Types.EventType, is_deleted: boolean, allowed_container_types: Array<{ __typename?: 'ContainerType', id: number, name: string, image?: string | null, packing_unit?: number | null, segment?: Types.ContainerTypeSegment | null, color_hex_code?: string | null }>, allowed_item_types: Array<{ __typename?: 'ItemType', id: number, name: string, image_url?: string | null, color_hex_code?: string | null, category: Types.ItemTypeCategory, archived: boolean }> } };


export const UpdateEventDocument = gql`
    mutation updateEvent($event_id: ID!, $input: UpdateEventInput!) {
  updateEvent(event_id: $event_id, input: $input) {
    ...EventReduced
  }
}
    ${EventReducedFragmentDoc}`;
export type UpdateEventMutationFn = Apollo.MutationFunction<UpdateEventMutation, UpdateEventMutationVariables>;

/**
 * __useUpdateEventMutation__
 *
 * To run a mutation, you first call `useUpdateEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEventMutation, { data, loading, error }] = useUpdateEventMutation({
 *   variables: {
 *      event_id: // value for 'event_id'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateEventMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEventMutation, UpdateEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEventMutation, UpdateEventMutationVariables>(UpdateEventDocument, options);
      }
export type UpdateEventMutationHookResult = ReturnType<typeof useUpdateEventMutation>;
export type UpdateEventMutationResult = Apollo.MutationResult<UpdateEventMutation>;
export type UpdateEventMutationOptions = Apollo.BaseMutationOptions<UpdateEventMutation, UpdateEventMutationVariables>;